import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput,MDBTable, MDBTableBody, MDBTableHead,  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { URL,api } from '../../api';
import Swal from 'sweetalert2'

export default class Modaldetailsbnlist extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

  send_type:'',
  detailsbn:[],
}


this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
}


 componentDidMount() {
    //  const { id_send } = this.props.id_send
    //  console.log(id_send);
      this.setState({ send_type:this.props.send_type})

      setTimeout(() => {
        //ภายใน
        api.get('registercon/selectdetailbnforbnex/'+this.props.send_type)
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ detailsbn: res.data})
      
  
        }) 
  
      }, 0);
  
   

  }




  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_Forgot", this.props.id_Forgot);
    
      
      api.post("registercon/updatestatusForgot",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
        Swal.fire({
            title: 'เพิ่มสถานะสำเร็จ',
            text: "Success status added",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง'
        }).then((result) => {
            if (result.isConfirmed) {
            // Swal.fire(
            //   'Deleted!',
            //   'Your file has been deleted.',
            //   'success'
            // )
          //  this.getExpertmaparticle();
            this.toggle()
            }
        })
    }else{
     // window.location.href = '/'
    }


  })

}, 2000);

  }

    render() {
        

        return (
            <MDBContainer>
            <MDBBtn color="mdb-color" size='sm' onClick={this.toggle}>บรรณาธิการ ประจำกลุ่ม</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>บรรณาธิการ ประจำกลุ่ม</MDBModalHeader>
              <MDBModalBody>
              <div className='text-center'>
              <MDBTable bordered responsive>
                    <MDBTableHead color="stylish-color" textWhite>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อ - นามสกุล</th>
                        <th>เบอร์โทร</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.detailsbn.map((detailsbn,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{detailsbn.name_expertbn}</td>
                        <td>{detailsbn.tel_expertbn	}</td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable>
                    

              </div>

             
              </MDBModalBody>

             
              <MDBModalFooter>
            
                <MDBBtn color="secondary" size='sm' onClick={this.toggle}>ปิด</MDBBtn>
               
              
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}


